export interface Option {
  value: string;
  label: string;
}

export const LANGUAGE_OPTIONS: Option[] = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' },
  { value: 'pt', label: 'Português' },
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'ru', label: 'Русский' },
  { value: 'zh-CN', label: '简体中文' },
  { value: 'zh-TW', label: '繁體中文' },
  { value: 'ja', label: '日本語' },
  { value: 'ko', label: '한국어' },
  { value: 'ar', label: 'العربية' },
  { value: 'hi', label: 'हिन्दी' },
  { value: 'bn', label: 'বাংলা' },
  { value: 'ta', label: 'தமிழ்' },
  { value: 'te', label: 'తెలుగు' },
  { value: 'ur', label: 'اردو' },
  { value: 'vi', label: 'Tiếng Việt' },
  { value: 'th', label: 'ไทย' },
  { value: 'id', label: 'Bahasa Indonesia' },
  { value: 'ms', label: 'Bahasa Melayu' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'pl', label: 'Polski' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'sv', label: 'Svenska' },
  { value: 'da', label: 'Dansk' },
  { value: 'fi', label: 'Suomi' },
  { value: 'no', label: 'Norsk' },
  { value: 'cs', label: 'Čeština' },
  { value: 'hu', label: 'Magyar' },
  { value: 'el', label: 'Ελληνικά' },
  { value: 'he', label: 'עברית' },
  { value: 'uk', label: 'Українська' },
  { value: 'ro', label: 'Română' },
  { value: 'bg', label: 'Български' },
  { value: 'fa', label: 'فارسی' },
  { value: 'sw', label: 'Kiswahili' },
  { value: 'fil', label: 'Filipino' },
  { value: 'sr', label: 'Српски' },
  { value: 'sk', label: 'Slovenčina' },
  { value: 'hr', label: 'Hrvatski' },
  { value: 'sl', label: 'Slovenščina' },
  { value: 'et', label: 'Eesti' },
  { value: 'lv', label: 'Latviešu' },
  { value: 'lt', label: 'Lietuvių' },
  { value: 'is', label: 'Íslenska' },
];

const DEFAULT_TIME_ZONES: string[] = [
  'UTC',
  // Americas
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Phoenix',
  'America/Anchorage',
  'America/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Edmonton',
  'America/Winnipeg',
  'America/Halifax',
  'America/St_Johns',
  'America/Detroit',
  'America/Mexico_City',
  'America/Guatemala',
  'America/Costa_Rica',
  'America/Panama',
  'America/Havana',
  'America/Puerto_Rico',
  'America/Bogota',
  'America/Lima',
  'America/Santiago',
  'America/Caracas',
  'America/Sao_Paulo',
  'America/Buenos_Aires',
  'America/Montevideo',
  // Europe
  'Europe/London',
  'Europe/Dublin',
  'Europe/Lisbon',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Amsterdam',
  'Europe/Brussels',
  'Europe/Madrid',
  'Europe/Rome',
  'Europe/Zurich',
  'Europe/Vienna',
  'Europe/Prague',
  'Europe/Budapest',
  'Europe/Warsaw',
  'Europe/Stockholm',
  'Europe/Oslo',
  'Europe/Copenhagen',
  'Europe/Helsinki',
  'Europe/Riga',
  'Europe/Tallinn',
  'Europe/Vilnius',
  'Europe/Minsk',
  'Europe/Kyiv',
  'Europe/Bucharest',
  'Europe/Sofia',
  'Europe/Belgrade',
  'Europe/Athens',
  'Europe/Istanbul',
  'Europe/Moscow',
  // Africa
  'Africa/Casablanca',
  'Africa/Algiers',
  'Africa/Tunis',
  'Africa/Cairo',
  'Africa/Lagos',
  'Africa/Accra',
  'Africa/Khartoum',
  'Africa/Addis_Ababa',
  'Africa/Nairobi',
  'Africa/Dar_es_Salaam',
  'Africa/Johannesburg',
  // Middle East
  'Asia/Jerusalem',
  'Asia/Beirut',
  'Asia/Baghdad',
  'Asia/Kuwait',
  'Asia/Riyadh',
  'Asia/Qatar',
  'Asia/Dubai',
  'Asia/Muscat',
  'Asia/Tehran',
  // Central Asia
  'Asia/Baku',
  'Asia/Tbilisi',
  'Asia/Yerevan',
  'Asia/Kabul',
  'Asia/Karachi',
  'Asia/Tashkent',
  'Asia/Almaty',
  // South Asia
  'Asia/Kolkata',
  'Asia/Colombo',
  'Asia/Kathmandu',
  'Asia/Dhaka',
  'Asia/Yangon',
  // Southeast Asia
  'Asia/Bangkok',
  'Asia/Ho_Chi_Minh',
  'Asia/Jakarta',
  'Asia/Makassar',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Asia/Brunei',
  'Asia/Manila',
  // East Asia
  'Asia/Shanghai',
  'Asia/Chongqing',
  'Asia/Urumqi',
  'Asia/Hong_Kong',
  'Asia/Macau',
  'Asia/Taipei',
  'Asia/Seoul',
  'Asia/Tokyo',
  // Australia
  'Australia/Perth',
  'Australia/Darwin',
  'Australia/Adelaide',
  'Australia/Brisbane',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Australia/Hobart',
  // Pacific
  'Pacific/Guam',
  'Pacific/Port_Moresby',
  'Pacific/Noumea',
  'Pacific/Auckland',
  'Pacific/Fiji',
  'Pacific/Tahiti',
  'Pacific/Honolulu',
  // Atlantic
  'Atlantic/Reykjavik',
  'Atlantic/Azores',
  'Atlantic/Cape_Verde',
  // Indian Ocean
  'Indian/Maldives',
  'Indian/Mauritius',
];

type IntlWithValues = typeof Intl & {
  supportedValuesOf?: (key: 'timeZone') => string[];
};

export function getTimeZoneOptions(): string[] {
  const intl = Intl as IntlWithValues;
  if (typeof intl.supportedValuesOf === 'function') {
    const zones = intl.supportedValuesOf('timeZone');
    if (Array.isArray(zones) && zones.length > 0) {
      return zones;
    }
  }
  return DEFAULT_TIME_ZONES;
}

export function normalizeTimeZones(options: string[]): string[] {
  return Array.from(new Set(options)).sort((a, b) => a.localeCompare(b));
}

export function formatTimeZoneWithOffset(zone: string): string {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      timeZoneName: 'shortOffset',
    });
    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find(p => p.type === 'timeZoneName');
    const offset = offsetPart?.value || '';
    return `${zone} (${offset})`;
  } catch {
    return zone;
  }
}

export function getTimeZoneOptionsWithOffset(): Option[] {
  const zones = normalizeTimeZones(getTimeZoneOptions());
  return zones.map(zone => ({
    value: zone,
    label: formatTimeZoneWithOffset(zone),
  }));
}

export function filterTimeZones(options: string[], query: string): string[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return options;
  }
  return options.filter((zone) => zone.toLowerCase().includes(normalized));
}

export function filterLanguageOptions(options: Option[], query: string): Option[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) {
    return options;
  }
  return options.filter((option) => option.label.toLowerCase().includes(normalized));
}
